import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBag = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M21 12.75H12M12 12.75H3M12 12.75L12.0022 15.25M8.0022 7.75V3.75H16.0022V7.75M21.25 20.25H2.75V7.75H21.25V20.25Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgBag;
